import React from 'react';

export interface ResponsiveContainerProps {
  children: React.ReactNode;
  /** Additional CSS class names */
  className?: string;
  /** HTML element to render (default: div) */
  as?: React.ElementType;
}

/**
 * Max-width container that adapts per breakpoint.
 * Uses CSS classes for responsive max-width and padding.
 */
export function ResponsiveContainer({
  children,
  className = '',
  as: Component = 'div',
}: ResponsiveContainerProps) {
  return (
    <Component className={`ipa-responsive-container ${className}`.trim()}>
      {children}
    </Component>
  );
}
